var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctorOnCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)",
    stroke: "#666",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.997 0H0v4.019a3.938 3.938 0 007.875 0V0h0-1.977M4.12 8.345v5.499a3.204 3.204 0 106.408 0v-2.765h0"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#666",
    cx: 10.5,
    cy: 10.375,
    r: 1.5
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#666",
    cx: 2,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#666",
    cx: 6,
    cy: 1,
    r: 1
  })))));
}
export default SvgDoctorOnCall;